import { z } from "zod/v4";

export const academySiteStatusSchema = z.enum(["pending", "live", "rejected"]);

export const academySiteSchema = z.object({
	academy_name: z.string().optional(),
	club_id: z.string().uuid(),
	id: z.string().uuid(),
	rejected_reason: z.string().nullable().optional(),
	requested_at: z.coerce.date(),
	requested_by: z.string().uuid(),
	reviewed_at: z.coerce.date().nullable().optional(),
	reviewed_by: z.string().uuid().nullable().optional(),
	status: academySiteStatusSchema,
	subdomain: z.string().min(3).max(32),
});

export type AcademySite = z.infer<typeof academySiteSchema>;
export type AcademySiteStatus = z.infer<typeof academySiteStatusSchema>;
